import { writable } from "svelte/store";

export const userAcc = writable(null);
export const countid = writable(null);
export const task_store = writable(null);
export const all_task_store = writable(null);

